module.exports = __webpack_public_path__ + "img/icon_profile_inactive_mob.96d38105.svg";